module.exports = __webpack_public_path__ + "style/img/Group 1781(1).5af9f763.png";